import { useMemo } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { USER_PROFILE_UPSERT, USER_PROFILES } from 'queries/UserProfile';

const UI_PREFERENCE_PREF = {
  app: 'cube-ui-preference',
  path: '/cube-ui-preference',
};

const useUiPreferences = ({ skip = false } = {}) => {
  const { data } = useQuery(USER_PROFILES, {
    skip,
    context: { clientName: 'common' },
    variables: { pref: UI_PREFERENCE_PREF },
    fetchPolicy: 'network-only',
  });

  const [updateUiPreferences] = useMutation(USER_PROFILE_UPSERT, {
    context: { clientName: 'common' },
  });

  const savedPreference = data?.getUserPreferences?.[0];
  const allPreferences = useMemo(() => {
    try {
      return savedPreference?.value ? JSON.parse(savedPreference.value) : {};
    } catch {
      return {};
    }
  }, [savedPreference?.value]);

  const updatePreferences = (preference) =>
    updateUiPreferences({
      variables: {
        pref: {
          app: 'cube-ui-preference',
          name: 'Cube UI Preference',
          path: '/cube-ui-preference',
          value: JSON.stringify({ ...allPreferences, ...preference }),
          key: savedPreference?.key ?? null,
        },
      },
    });

  return { allPreferences, savedPreference, updatePreferences };
};

export default useUiPreferences;
